import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';

export const REGISTRATION_FAILED = 0;
export const REGISTRATION_SUCCESS = 1;
export const REGISTRATION_MISSING_PREFIX = 2;

export const SOCIAL_CONNECT_LOGIN = gql`
  mutation socialConnectLogin($type: String!, $code: String, $idToken: String, $prefix: String) {
    socialConnectLogin(type: $type, code: $code, idToken: $idToken, prefix: $prefix) {
      status
      message
      customerData {
        customerId
        token
      }
    }
  }
`;

export const useSocialLoginMutation = (options = {}) =>
  useMutation(SOCIAL_CONNECT_LOGIN, {
    refetchQueries: ['Customer', 'Cart', 'MiniCart', 'CustomerWithAddresses', 'ProductsInWishlist'],
    ...options
  });
